import * as React from 'react';
import { useState, useEffect } from 'react';
import Toggle from '../../../../common/Toggle';
import { Question } from '@nexxt/common/types';
import axios from 'axios';

interface QualityControlSettingsProps {
    question: Question;
    setQuestion: (question: Question) => void;
}

const CUSTOM_TRAINED_MODELS = [
    { id: 'MMR_SENSORY_BOT_ISA', label: 'Sensory Bot' }
];

const TOUCHPOINT_MODIFIERS = [
    'Intensity',
    'Duration',
    'Interaction',
    'Shape Expectations',
    'Emotion',
    'Product Association'
];

const CustomTrainedModelSettings = ({
    question,
    // settings,
    // disabled,
    setQuestion
}: QualityControlSettingsProps): JSX.Element => {
    // const { qualityControlSettings } = question.conversationalSettings;
    const [subj, setSubj] = useState(
        question?.conversationalSettings?.dialoguePolicy?.subj ?? ''
    );
    const [productContext, setProductContext] = useState(
        question?.conversationalSettings?.dialoguePolicy?.productContext ?? ''
    );
    const [touchpointsInp, setTouchpointsInp] = useState(
        question?.conversationalSettings?.dialoguePolicy?.touchpointsInp ?? ''
    );
    const [touchpoints, setTouchpoints] = useState(
        question?.conversationalSettings?.dialoguePolicy?.touchpoints ?? []
    );
    const [isGenerating, setIsGenerating] = useState(false);
    const customModel = CUSTOM_TRAINED_MODELS[0];

    useEffect(() => {
        setQuestion({
            ...question,
            conversationalSettings: {
                ...question.conversationalSettings,
                dialoguePolicy: {
                    policy: 'sensory-bot-isa',
                    touchpoints,
                    subj,
                    productContext,
                    touchpointsInp
                }
            }
        });
    }, [touchpoints, subj, productContext]);

    const handleGenerateTouchpoints = async () => {
        console.log({ touchpointsInp });
        setIsGenerating(true);
        const newTouchpointLabels = touchpointsInp.split('\n').filter((t) => t);
        const body = {
            touchpoint_labels: newTouchpointLabels,
            subj: subj,
            context: productContext
        };
        const intros = (await axios.post('https://test.inca.chat/intros', body))
            .data;

        const newTouchpoints = newTouchpointLabels.map((t, idx) => {
            const existingTouchpoint = touchpoints.find((t2) => t2.label == t);

            return {
                label: t,
                intro: existingTouchpoint?.intro ?? intros[idx],
                modifiers:
                    existingTouchpoint?.modifiers ??
                    Object.fromEntries(
                        TOUCHPOINT_MODIFIERS.map((mod) => [mod, false])
                    )
            };
        });
        setTouchpoints(newTouchpoints);
        setIsGenerating(false);
    };

    const handleTouchpointIntroChange = (
        targetIdx: number,
        newIntro: string
    ) => {
        const newTouchpoints = [
            ...touchpoints.slice(0, targetIdx),
            { ...touchpoints[targetIdx], intro: newIntro },
            ...touchpoints.slice(targetIdx + 1)
        ];
        setTouchpoints(newTouchpoints);
    };

    const handleTouchpointModifierChange = (
        targetIdx: number,
        modifierKey: string,
        modifierValue: boolean
    ) => {
        const newTouchpoints = [
            ...touchpoints.slice(0, targetIdx),
            {
                ...touchpoints[targetIdx],
                modifiers: {
                    ...touchpoints[targetIdx].modifiers,
                    [modifierKey]: modifierValue
                }
            },
            ...touchpoints.slice(targetIdx + 1)
        ];
        setTouchpoints(newTouchpoints);
    };

    return (
        <div className="form-group p-4">
            <div className="font-semibold text-lg mb-4">
                Custom Trained Model: {customModel.label}
            </div>
            <label className="font-bold">Product Subject</label>
            <br />
            <input
                placeholder="chocolate"
                className="w-full border-solid border-sky-300 border-2"
                style={{ width: '720px' }}
                value={subj}
                onChange={(e) => setSubj(e.target.value)}
            />
            <br />
            <label className="font-bold">Product Context</label>
            <br />
            <input
                value={productContext}
                className="w-full border-solid border-sky-300 border-2"
                style={{ width: '720px' }}
                onChange={(e) => setProductContext(e.target.value)}
                placeholder="While enjoying this conference session, you’ve just been handed a chocolate bar, please do not open it just yet!"
            />
            <br />
            <label className="font-bold">Touchpoints</label>
            <br />
            <span className="font-bold">Enter one per line.</span>
            <br />
            <textarea
                value={touchpointsInp}
                className="w-720 border-solid border-sky-300 border-2"
                style={{ width: '720px', height: '200px' }}
                onChange={(e) => setTouchpointsInp(e.target.value)}
                placeholder="PACKAGING (LOOK)&#10;PACKAGING (FEEL)&#10;APPEARANCE OF THE BAR&#10;AROMA&#10;FLAVOUR&#10;MOUTHFEEL/TEXTURE&#10;AFTERTASTE"
            />
            <br />
            {isGenerating ? (
                <span>Generating...</span>
            ) : (
                <button
                    className="btn btn--blue"
                    onClick={handleGenerateTouchpoints}
                >
                    Generate Touchpoints
                </button>
            )}
            {touchpoints.map((t, idx) => (
                <div
                    className="border-solid border-black border-2 m-2 p-2"
                    key={t.label}
                >
                    <b>{t.label}</b>
                    <br />
                    <input
                        value={t.intro}
                        className="w-full border-solid border-sky-300 border-2"
                        style={{ width: '720px' }}
                        onChange={(e) =>
                            handleTouchpointIntroChange(idx, e.target.value)
                        }
                    />
                    <br />
                    {TOUCHPOINT_MODIFIERS.map((modifier) => (
                        <div key={modifier} className="m-2">
                            <label className="font-semibold mb-1">
                                {modifier}
                            </label>
                            <Toggle
                                className="without-label -mt-3"
                                onChange={(value) =>
                                    handleTouchpointModifierChange(
                                        idx,
                                        modifier,
                                        value
                                    )
                                }
                                checked={t.modifiers[modifier]}
                            />
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
};

export default CustomTrainedModelSettings;
